import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";
import SectionHeader from "@/components/feature/SectionHeader";

function Categories() {
  return (
    <section className="border-y border-background-800 bg-background-900/40 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="Premium Zones"
          title="四大专属漫画专区"
          desc="尊享、钻石、贵族、豪华四大专区，以不同格调满足你对高品质漫画的每一种想象。"
          align="center"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((cat, i) => (
            <Link
              key={cat.id}
              to="/category"
              className={`group relative overflow-hidden rounded-lg border border-background-800 p-7 transition hover:border-primary-500/40 hover:-translate-y-1 ${
                i % 2 === 0 ? "bg-background-950" : "bg-background-800/60"
              }`}
            >
              <div className="absolute -right-6 -top-6 h-24 w-24 rounded-full bg-primary-500/5 blur-2xl group-hover:bg-primary-500/15 transition"></div>
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-accent-500 text-xl text-foreground-950">
                <i className={cat.icon}></i>
              </span>
              <h3 className="mt-5 font-heading text-xl font-bold text-foreground-50">{cat.name}</h3>
              <p className="mt-1 text-xs font-semibold uppercase tracking-widest text-primary-400">
                {cat.tagline}
              </p>
              <p className="mt-3 text-sm leading-6 text-foreground-400">{cat.desc}</p>
              <div className="mt-5 flex items-center justify-between">
                <span className="text-xs text-foreground-500">{cat.count}精选</span>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-300 group-hover:gap-2 transition-all">
                  进入专区
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Categories;